function renderImageCellMediaLayoutTemplate({
  imageUrlExpression,
  titleFallback,
  split
}: {
  imageUrlExpression: string
  titleFallback: string
  split: string
}): string {
  return `const imageUrl = ${imageUrlExpression} ?? ''
      const title = ${titleFallback}
      return (
        <div className="flex items-center gap-4 h-full pl-1">
          <Checkbox
            checked={row.getIsSelected()}
            onCheckedChange={(value) => row.toggleSelected(!!value)}
            aria-label="Select row"
          />
          ${split}
        </div>
      )`
}

function renderImageCellMediaTemplate({
  imageUrlExpression,
  titleFallback,
  imageElement
}: {
  imageUrlExpression: string
  titleFallback: string
  imageElement: string
}): string {
  return `const imageUrl = ${imageUrlExpression} ?? ''
      const title = ${titleFallback}
      return (
        ${imageElement}
      )`
}

export function renderImageCellMediaRenderer(
  request:
    | {
        kind: 'renderImageCellMediaLayoutTemplate'
        props: {
          imageUrlExpression: string
          titleFallback: string
          split: string
        }
      }
    | {
        kind: 'renderImageCellMediaTemplate'
        props: {
          imageUrlExpression: string
          titleFallback: string
          imageElement: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderImageCellMediaLayoutTemplate':
      return renderImageCellMediaLayoutTemplate(request.props)
    case 'renderImageCellMediaTemplate':
      return renderImageCellMediaTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
